import React from 'react';
import clsx from 'clsx';
import LinkCell from '@/components/table/LinkCell';

const FormObjectTextCell = ({ field, item }) => (
  <LinkCell
    className={clsx(`aridhia-form-object-text-cell-${field.type}`, 'td-description')}
    value={item[field.name]}
  />
);

export default FormObjectTextCell;
